// 도서/산간 지역 배송비 섹션 URL (2026-08-24 KST 추가)
const shippingRegionsSection = "/shipping-regions";

export const shippingRegionsPath = shippingRegionsSection;
